import { render, staticRenderFns } from "./SpinnerLoading.vue?vue&type=template&id=ffe57310&scoped=true"
import script from "./SpinnerLoading.vue?vue&type=script&lang=js"
export * from "./SpinnerLoading.vue?vue&type=script&lang=js"
import style0 from "./SpinnerLoading.vue?vue&type=style&index=0&id=ffe57310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe57310",
  null
  
)

export default component.exports